import React from 'react';
import { motion } from 'framer-motion';
import { poojaTypesData } from '../config/poojaConfig'; // Import from config
import { useLanguage } from '../contexts/LanguageContext';
import './PoojaTypes.css';

const PoojaTypes = ({ onPoojaSelect, poojaList = poojaTypesData }) => {
  const { t } = useLanguage();

  const handlePoojaClick = (pooja) => {
    const bookingSafePooja = pooja?.bookingTypeId
      ? { ...pooja, id: pooja.bookingTypeId }
      : pooja;

    if (typeof onPoojaSelect === 'function') {
      onPoojaSelect(bookingSafePooja);
    }

    // Scroll to booking form
    const bookingSection = document.querySelector('.booking-form-section');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pooja-types">
      <div className="container">
        <div className="section-header">
          <h2>{t('onlinePooja.poojaTypes.sectionTitle')}</h2>
          <p>{t('onlinePooja.poojaTypes.sectionSubtitle')}</p>
        </div>
        <div className="pooja-grid">
          {poojaList.map((pooja, index) => (
            <motion.div
              key={pooja.id}
              className={`pooja-card ${pooja.featured ? 'featured' : ''}`}
              onClick={() => handlePoojaClick(pooja)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.05, y: -10 }}
              whileTap={{ scale: 0.98 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              {pooja.featured && (
                <div className="pooja-badge">{t('onlinePooja.poojaTypes.mostPopular')}</div>
              )}
              <div className="pooja-icon">
                <i className={pooja.icon}></i>
              </div>
              {pooja.categoryLabel && (
                <div className="pooja-category-label">{pooja.categoryLabel}</div>
              )}
              <h3>{t(`onlinePooja.poojaTypes.items.${pooja.id}.title`, {}, pooja.title)}</h3>
              <p>{t(`onlinePooja.poojaTypes.items.${pooja.id}.description`, {}, pooja.description)}</p>
              <div className="pooja-price">₹ {pooja.price}</div>
              <button type="button" className="btn btn-primary">{t('onlinePooja.poojaTypes.bookNow')}</button>
            </motion.div>
          ))}
        </div>
        {poojaList.length === 0 && (
          <div className="pooja-no-results">
            <p>{t('onlinePooja.filters.noResults', {}, 'No pooja found for selected filters. Please clear filters and try again.')}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PoojaTypes;












